export default (boolean: boolean): boolean | null => {
  if (typeof boolean !== 'boolean') {
    return null;
  }
  return boolean;
};
